import React from 'react';
import { motion } from 'framer-motion';
export function Transformation() {
  return <section className="py-14 bg-white overflow-hidden" data-id="element-224">
      <div className="max-w-4xl mx-auto px-6" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative mb-10 max-w-2xl lg:max-w-3xl mx-auto" data-id="element-226">
          <div className="absolute -inset-4 border border-gold/30 translate-x-2 translate-y-2" data-id="element-227"></div>
          <img src="https://cdn.magicpatterns.com/uploads/qcHMbTdffphz2mZE913v82/ChatGPT_Image_11_may_2026,_07_51_41_p.m..png" alt="Antes y después: de la persecución a la calma" className="relative z-10 w-full h-auto object-contain" data-id="element-228" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-229">
          <h2 className="text-3xl sm:text-4xl font-playfair text-deep-black mb-6 leading-tight text-center" data-id="element-230">
            De la persecución a la{' '}
            <span className="italic text-bordeaux" data-id="element-231">calma</span>
          </h2>

          <div className="space-y-6 font-inter text-gray-700 text-lg leading-relaxed" data-id="element-232">
            <div data-id="element-233">
              <h3 className="text-sm font-bold tracking-widest text-gray-400 uppercase mb-3" data-id="element-234">
                Antes
              </h3>
              <p data-id="element-235">
                <strong className="font-bold text-deep-black" data-id="element-236">
                  Su silencio lo significaba todo.
                </strong>{' '}
                Sentías la necesidad de escribirle primero, explicarle, arreglar
                las cosas o demostrar que valías la pena. Su{' '}
                <em className="not-italic underline decoration-bordeaux/40 decoration-2 underline-offset-2" data-id="element-237">
                  inconsistencia te desarmaba
                </em>{' '}
                por completo: afectaba tu estado de ánimo, tu confianza y tu
                autoestima.
              </p>
            </div>

            <div className="pl-6 border-l-2 border-bordeaux" data-id="element-238">
              <h3 className="text-sm font-bold tracking-widest text-bordeaux uppercase mb-3" data-id="element-239">
                Después
              </h3>
              <p className="text-deep-black font-medium" data-id="element-240">
                Sabes{' '}
                <span className="bg-gold/25 px-1 rounded-sm" data-id="element-241">
                  exactamente cómo reaccionar
                </span>{' '}
                cuando su energía cambiaba. Dejas de reaccionar por miedo y
                empezas a responder con seguridad, con una{' '}
                <strong className="font-bold" data-id="element-242">calma poderosa</strong>, con
                fortaleza.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}